import React from "react";
import styled, {withTheme} from "styled-components/macro";
import {darken} from "polished";

import {
    Grid,
    Hidden,
    AppBar as MuiAppBar,
    IconButton as MuiIconButton,
    Toolbar,
} from "@mui/material";

import {Menu as MenuIcon} from "@mui/icons-material";

import NotificationsDropdown from "./NotificationsDropdown";
import UserDropdown from "./UserDropdown";
import SiUserManual
 from "../pages/shipping-instructions/si-user-manual";
 
const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

  const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Search = styled.div`
  border-radius: 2px;
  background-color: ${(props) => props.theme.header.background};
  display: none;
  position: relative;
  width: 100%;

  &:hover {
    background-color: ${(props) => darken(0.05, props.theme.header.background)};
  }

  ${(props) => props.theme.breakpoints.up("md")} {
    display: block;
  }
`;

const SearchIconWrapper = styled.div`
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 22px;
    height: 22px;
  }
`;


const AppBarComponent = ({onDrawerToggle}) => (
    <React.Fragment>
        <AppBar position="sticky" elevation={0}>
            <Toolbar>
                <Grid container alignItems="center">
                    <Hidden mdUp>
                        <Grid item>
                            <IconButton
                                color="inherit"
                                aria-label="Open drawer"
                                onClick={onDrawerToggle}
                                size="large">
                                <MenuIcon/>
                            </IconButton>
                        </Grid>
                    </Hidden>
                    <Grid item>
                        <Search>
                            <SearchIconWrapper />
                        </Search>
                    </Grid>
                    <Grid item xs/>
                    <Grid item>
                        <SiUserManual />
                        {/* <NotificationsDropdown/>
                        <UserDropdown/> */}
                    </Grid>
                </Grid>
            </Toolbar>
        </AppBar>
    </React.Fragment>
);

export default withTheme(AppBarComponent);
